const regionalStrings = {
  enUS: {
    loading: 'Loading...',
    letsChat: "Let's talk",
    startCall: 'Start',
    endCall: 'End',
    mute: 'Mute',
    unmute: 'Unmute',
    callDuration: 'Call Duration',
    introMessage:
      'Ask our interactive voice agent about the report, test the technology, and hear the future of AI.',
    poweredBy: 'Conversational AI, powered by Twilio',
    conversationRelay: 'ConversationRelay',
    tokenExpired:
      'The call token has expired. Please refresh the page to start a new conversation.',
    webRTCInitializationFailed:
      'Failed to initialize WebRTC device. Please refresh the page.',
    seeConversationalAIInActionSee: 'See ',
    seeConversationalAIInActionConversationalAI: 'Conversational AI',
    seeConversationalAIInActionInAction: 'in action',
  },
  esES: {
    loading: 'Cargando...',
    letsChat: 'Hablemos',
    startCall: 'Iniciar',
    endCall: 'Finalizar',
    mute: 'Silenciar',
    unmute: 'Activar sonido',
    callDuration: 'Duración de la llamada',
    introMessage:
      'Pregunta a nuestro agente de voz interactivo sobre el informe, prueba la tecnología y escucha el futuro de la IA.',
    poweredBy: 'Inteligencia conversacional, impulsada por Twilio',
    conversationRelay: 'ConversationRelay',
    tokenExpired:
      'El token de la llamada ha expirado. Por favor, actualiza la página para iniciar una nueva conversación.',
    webRTCInitializationFailed:
      'Error al inicializar el dispositivo WebRTC. Por favor, actualiza la página.',
    seeConversationalAIInActionSee: 'Ver ',
    seeConversationalAIInActionConversationalAI: 'IA conversacional',
    seeConversationalAIInActionInAction: 'en acción',
  },
};

export const translation = (token, language) => {
  if (language === 'en-US') {
    return regionalStrings.enUS[token];
  } else if (language === 'es-ES') {
    return regionalStrings.esES[token];
  }

  // Add more translations here
  return regionalStrings.enUS[token];
};
